import React, { useState, useEffect } from "react";
import { Modal, Box, Button, TextField, Typography} from "@mui/material";
import { addCable } from "./CreateNewModal.util";
import { useMsal } from '@azure/msal-react';

const CreateNewModal = ({
  sau,
  exchange,
  url2,
  setMUCJTableData,viewjobid,setLoading,setSelectedMUCJRows,setAlertOpen,setSnackMsg,setSuccessAlertOpen,setSuccessSnackMsg,setMucjLoader

}) => {

  const { accounts } = useMsal();
  let params = {
    logged_user: accounts[0]?.idTokenClaims.EIN
}

  const initialFormData = {
    ein: "",
    first_name: "",
    last_name: "",
    email_id: "",
    cable: "",
    sau: "",
    exchange: "",
    cable_weight: "",
    cable_length: "",
    cable_gauge: "",
  };
 
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const handleOpenCreateModal = () => {
    setOpenCreateModal(true);  
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      sau: sau,
      exchange: exchange,
    }));
  }, [sau, exchange]);

  //Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "", // Clear error for the field being updated
    });
  };

  // Validate inputs
  const validateInputs = () => {
    const newErrors = {};
    if (!formData.cable) newErrors.cable = "Cable ID is required.";
    if (!formData.cable_weight || isNaN(formData.cable_weight))
      newErrors.cable_weight = "Weight is required to be a valid number.";
    if (!formData.cable_length || !/^\d+$/.test(formData.cable_length))
      newErrors.cable_length = "Length must be an integer.";
    if (!formData.cable_gauge ||!/^\d+$/.test(formData.cable_gauge))
      newErrors.cable_gauge = "Cable Gauge must be an integer.";
    return newErrors;
  };
 
  
 
  
  // Function to reset form data
  const resetFormData = () => {
      setFormData({
          ...initialFormData,
          sau: sau, 
          exchange: exchange, 
      });
      setErrors({});
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
 
    const validationErrors = validateInputs();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setOpenCreateModal(false);
    await addCable(setMucjLoader,formData, setAlertOpen,setSnackMsg,setSuccessAlertOpen,setSuccessSnackMsg, setOpenCreateModal, params,setMUCJTableData,viewjobid,setLoading,setSelectedMUCJRows,url2);
    resetFormData();
   
  };

  const handleClose = () => {
    resetFormData(); 
    setOpenCreateModal(false);
  };

  return (
    <div>
      <Button variant="outlined" id='mucj-create-button'style={{ color: "white", backgroundColor: "#142032", marginBottom: "10px" ,fontSize:"12",height:"30px"}} onClick={handleOpenCreateModal}>CREATE NEW</Button>

      <Modal open={openCreateModal} >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            pt: 2,
            pb: 3,
            pl: 3,
            pr: 3,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" sx={{ pb: 1 }}>Create New Cable</Typography>
          <form
          id="create-cable-form"
            onSubmit={handleSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <TextField
              id="create-cableid"
              label="Cable ID"
              name="cable"
              value={formData.cable}
              onChange={handleChange}
               size="small"
               error={!!errors.cable}
               helperText={errors.cable}
            />
            <TextField
            id="create-cable-weight"
              label="Weight(Tonnes)"
              name="cable_weight"
              value={formData.cable_weight}
              onChange={handleChange}
               size="small"
               error={!!errors.cable_weight}
              helperText={errors.cable_weight}
              type="number"

            />
            <TextField
            id="create-cable-length"
              label="Length(m)"
              name="cable_length"
              value={formData.cable_length}
              onChange={handleChange}
               size="small"
               error={!!errors.cable_length}
               helperText={errors.cable_length}
               type="number"

            />
            <TextField
            id="create-cable-gauge"
              label="Cable Gauge"
              name="cable_gauge"
              value={formData.cable_gauge}
              onChange={handleChange}
               size="small"
               error={!!errors.cable_gauge}
               helperText={errors.cable_gauge}
               type="number"

            />
            <Box sx={{ display: 'flex',justifyContent:'center',mt: 2 }}>
              <Button
                id="mucj-create-cancel-button"
                style={{ color: "white", backgroundColor: "#142032", fontSize: "12", height: "30px",marginRight: "10px" }}
                onClick={handleClose}
                sx={{ mr: 1 }}
              >
                CANCEL
              </Button>
              <Button
              id="mucj-create-apply-button"
                type="submit"
                variant="contained"
                style={{ color: "white", backgroundColor: "#142032", fontSize: "12", height: "30px" }}
              >APPLY
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default CreateNewModal;
